import _ from 'underscore';
import vex from 'vex-js';
import Player from '@vimeo/player'

class Video {

 constructor() {
   this.bind();
 };

 bind() {
   $('[data-video]').on('click', event => {
     event.preventDefault();
     var $button = $(event.currentTarget);
     if (typeof ga !== 'undefined') {
       ga('send', 'event', 'Videos', 'play', $button.data('video-title'));
     }
     this.popup({
       title: $button.data('video-title'),
       caption: $button.data('video-caption'),
       id: $button.data('video-id'),
       protocol: window.location.protocol
     });
   });
 }

 template(video) {
   return `
   <div class="small-12 medium-8 large-10 medium-centered columns vex-video">
     <div class="vex-close"></div>
     <br/><br/>
     <h4>${video.title}</h4>
     <div class="vex-video-container">
       <iframe src="${video.protocol}//player.vimeo.com/video/${video.id}?api=1&player_id=vimeo_${video.id}?title=0&byline=0&portrait=0&badge=0&autoplay=1" id="vimeo_${video.id}" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" ></iframe>
     </div>
     <p class="caption">${video.caption}</p>
   </div>
   `;
 }

 popup(video) {
   let content = this.template(video);
   vex.open({
     content: content,
     overlayClosesOnClick: false,
     showCloseButton: false,
     appendLocation: '#app',
     afterOpen: $content => {
       $content.addClass('wide');
       let player = new Player('vimeo_' + video.id);
       player.on('ready', event => {
         //console.log(id);
         //player.api('play');
       });
       $content.find('.vex-close').on('click', event=> {
         vex.close($content.data().vex.id);
       });
     }
   });
 }
}

export { Video as default };
